export default "__VITE_ASSET__C81dYgib__"